import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["tab", "panel"];
  static classes = ["active", "inactive"];

  connect() {
    this.showTab(0); // Default to first tab
  }

  switch(event) {
    event.preventDefault();
    const index = this.tabTargets.indexOf(event.currentTarget);
    this.showTab(index);
  }

  showTab(index) {
    // Update tab styles
    this.tabTargets.forEach((tab, i) => {
      if (i === index) {
        tab.classList.add(...this.activeClasses);
        tab.classList.remove(...this.inactiveClasses);
        tab.setAttribute("aria-selected", "true");
      } else {
        tab.classList.remove(...this.activeClasses);
        tab.classList.add(...this.inactiveClasses);
        tab.setAttribute("aria-selected", "false");
      }
    });

    // Show/hide panels
    this.panelTargets.forEach((panel, i) => {
      panel.hidden = i !== index;
    });
  }
}
